import React from "react"
import { Typography, Card } from "antd"
import { Animated } from "react-animated-css"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../../components/Layout"
import TrustedBy from "../../components/TrustedBy"
import DevelopmentProcess from "../../components/WEB_DevelopmentProcess"
import CtaBanner from "../../components/AI_CtaBanner"
import SideForm from "./../../components/SideForm"
import behindImageSmall from "../../images/Group 495@2x.png"
import manual_testing from '../../images/manual_testing-01.png'
import mobile_testing from '../../images/mobile_testing-01.png'
import saas_testing from '../../images/saas_testing-01.png'
import usability_testing from '../../images/usability_testing-01.png'
import web_testing from '../../images/web_testing-01.png'
import ServiceCard from "../../components/ServiceCard"
import ServiceStepsProcess from "../../components/ServiceStepsProcess"

import "../../styles/services.scss"
import "../../styles/animate.css"
import FeaturedWork from "../../components/AI_FeaturedWork"
import AIAssistantCarousel from "../../components/AIAssistantCarousel"

const { Title } = Typography

const Index = ({ data }) => {
  const backgroundImage = data.bgImage.childImageSharp.fluid.src
  return (
    <Layout className="services-page-container" data={data} 
    pageTitle={"Visiomate - AI Solutions & Custom AI Development"}
    descrip = {"Build smarter software with Visiomate's AI solutions — custom AI development, chatbot creation, machine learning integration, process automation, and enterprise AI tailored for SMEs."}>
      <div className="top-section"
        style={{ backgroundImage: `url(${backgroundImage})` }}>
        {/* <div className="logo">
          <Link to="/" >
            <Img fluid={data.VMLogoWhite.childImageSharp.fluid} />
          </Link>
        </div> */}

        <div className="box-wrapper text-and-form-container" style={{ gridTemplateColumns: '1fr', textAlign: 'center' }}>
          <div className="information">
            <Animated
              animationIn="fadeInUp"
              animationInDuration={500}
              animationInDelay={300}
              isVisible={true}
            >
              <Title>Custom AI Development That Turns Data Into Competitive Advantage</Title>
              <br />
              <p>
                We build production-ready AI solutions — from custom machine learning models and intelligent chatbots to enterprise AI integrations and end-to-end process automation.
                Every solution is designed around your specific data, workflows, and business goals — not generic toolkits — so you see measurable ROI from day one.
              </p>
              {/* <TrustedBy showHeading={false} /> */}
            </Animated>
          </div>
          {/* <Animated
            animationIn="fadeInDown"
            animationInDuration={800}
            animationInDelay={500}
            isVisible={true}
            className="form"
          >
            <SideForm />
          </Animated> */}
        </div>
      </div>
      <div className="services-description-section">
      <div className="service-heading-and-detail">
        <Title>What We Can Build For You</Title>
      </div>
      <div className="service-cards-wrapper">
        <ServiceCard img_src={manual_testing} img_alt={'Custom AI software built for your workflows'} card_heading={'Get AI Built Around Your Business'} card_para={'Generic AI tools were not designed for your workflows. We build custom AI software from the ground up — trained on your data, aligned with your processes — so you get a competitive edge, not a commodity tool.'}/>
        <ServiceCard img_src={usability_testing} img_alt={'AI chatbot development for customer support and lead generation'} card_heading={'Answer Customer Questions Instantly, 24/7'} card_para={'Your support team cannot scale indefinitely. We build AI chatbots using NLP and LLMs that handle enquiries, qualify leads, and resolve issues around the clock — freeing your team for high-value work.'}/>
        <ServiceCard img_src={web_testing} img_alt={'Machine learning integration for smarter business decisions'} card_heading={'Make Smarter Decisions With Your Own Data'} card_para={'Most businesses are sitting on data they are not using. We integrate machine learning models into your systems to surface patterns, predict outcomes, and turn raw data into actionable intelligence.'}/>
        <ServiceCard img_src={mobile_testing} img_alt={'Enterprise AI integration into existing ERP and CRM systems'} card_heading={'Embed AI Into the Tools You Already Use'} card_para={'AI should not live in a separate dashboard. We integrate AI capabilities directly into your existing ERP, CRM, and workflows — so your team gets smarter insights without changing how they work.'}/>
        <ServiceCard img_src={saas_testing} img_alt={'AI-powered business process automation'} card_heading={'Eliminate Repetitive Work Across Your Team'} card_para={'Manual processes slow teams down and introduce errors. We automate high-volume, rule-based workflows using AI — cutting operational overhead and letting your people focus on work that needs human judgement.'}/>
        <ServiceCard card_heading={'Let connect, book a free consultancy session with our experts'} card_button={"Free Consultancy"}/>
      </div>
        {/* <div className="behindimagediv">
            <img
              className="behindImageSmall"
              src={behindImageSmall}
              alt="yellow-triangle"
            />
            <img className="behindImageLarg" src={behindImageSmall} alt="yellow-triangle" />
        </div> */}
      </div>
      <AIAssistantCarousel />
      <div className="featured-projects" style={{ background: '#ffffff' }}>
        <FeaturedWork data={data} />
      </div>
      <DevelopmentProcess title='How We Build and Deploy Your AI Solution' style={{ background: '#f4f5f7' }}>
        <ServiceStepsProcess process_heading='Discovery & Data Assessment' process_para="We start by understanding your business goals, existing data sources, and the problem AI needs to solve. We audit data quality, identify gaps, and define measurable success criteria before writing a single line of code." process_step_number="1" process_indentify="odd" />
        <ServiceStepsProcess process_heading='Solution Design & Model Selection' process_para="We design the AI architecture — selecting or fine-tuning the right models, defining the data pipeline, and mapping integrations with your existing systems. You see exactly what will be built before we begin." process_step_number="2" />
        <ServiceStepsProcess process_heading='Development & Training' process_para="Our engineers build the pipelines, train or integrate the models, and develop the application layer. We iterate in sprints so you can test outputs early and guide the solution toward real-world accuracy." process_step_number="3" process_indentify="odd" iconShow="dark"/>
        <ServiceStepsProcess process_heading='Evaluation & Refinement' process_para="We test the solution rigorously against your data and edge cases, measuring accuracy, latency, and business impact. Feedback from your team shapes the final refinements before production release." process_step_number="4" iconShow="dark" />
        <ServiceStepsProcess process_heading='Deployment & Continuous Improvement' process_para="We deploy to production with full monitoring, logging, and alerting in place. Post-launch, we track model performance over time and retrain or update as your data evolves — keeping your AI sharp." process_step_number="5" process_indentify="odd" />
      </DevelopmentProcess>
      <CtaBanner />
    </Layout>
  )
}

export default Index

export const  aiSolution= graphql`
  query aiSolution {
    BigJerry: file(relativePath: { eq: "bigjerrysfencing_aichatbot1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
  }
    bgImage: file(relativePath: { eq: "Mask_group8.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
